// How a Striping Plan intersection looks on the map (spec 2026-10-14 Part B): a
// numbered circle; amber with a warning when it is off the road; larger when selected.
export const STRIPING_ROUTE_COLOR = '#f97316';
const OFF_ROAD = 'not on the road — the striping plan will ignore it';

export const stripingMarkerDescriptor = (row, { selected = false } = {}) => ({
  title: row.offRoad ? `${row.displayName}: ${OFF_ROAD}` : row.displayName,
  labelText: String(row.number),
  fillColor: row.offRoad ? '#f59e0b' : '#2563eb',
  strokeColor: selected ? '#facc15' : '#ffffff',
  scale: selected ? 13 : 10,
  zIndex: selected ? 1001 : 1000,
});

export const toGoogleMarkerOptions = (d, g) => ({
  title: d.title,
  zIndex: d.zIndex,
  label: { text: d.labelText, color: '#ffffff', fontSize: '11px', fontWeight: '700' },
  icon: {
    path: g.SymbolPath.CIRCLE,
    scale: d.scale,
    fillColor: d.fillColor,
    fillOpacity: 1,
    strokeColor: d.strokeColor,
    strokeWeight: 2,
  },
});
